var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Column, CreateDateColumn, Entity, Index, PrimaryGeneratedColumn, UpdateDateColumn } from 'typeorm';
import { getLongTextEntityType } from '@/common/config';
let MSafe = class MSafe {
    id;
    address;
    creationNonce;
    creator;
    name;
    description;
    threshold;
    metadata;
    updatedAt;
    createdAt;
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], MSafe.prototype, "id", void 0);
__decorate([
    Column(),
    Index({ unique: true }),
    __metadata("design:type", String)
], MSafe.prototype, "address", void 0);
__decorate([
    Column({ nullable: true }),
    __metadata("design:type", Number)
], MSafe.prototype, "creationNonce", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], MSafe.prototype, "creator", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], MSafe.prototype, "name", void 0);
__decorate([
    Column('text', { nullable: true }),
    __metadata("design:type", String)
], MSafe.prototype, "description", void 0);
__decorate([
    Column(),
    __metadata("design:type", Number)
], MSafe.prototype, "threshold", void 0);
__decorate([
    Column(getLongTextEntityType(), { nullable: true }),
    __metadata("design:type", String)
], MSafe.prototype, "metadata", void 0);
__decorate([
    UpdateDateColumn(),
    __metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], MSafe.prototype, "updatedAt", void 0);
__decorate([
    CreateDateColumn(),
    __metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], MSafe.prototype, "createdAt", void 0);
MSafe = __decorate([
    Entity({ name: 'msafe' })
], MSafe);
export { MSafe };
//# sourceMappingURL=module.js.map